export default __webpack_public_path__ + "static/media/sleep-eval.bd91153f.svg";